<script>
export default {
  name: 'TeamRaisedAmount',
  props: {
    team: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between items-end mb-2">
    <h2 class="text-2xl lg:text-3xl font-medium">
      {{ team.cached.raised_formatted }}
    </h2>
    <span class="text-sm font-sans font-medium mb-[2px]">
      {{ team.cached.percentage_raised_formatted }} of ${{ team.goal_formatted }} goal
    </span>
  </div>
</template>

<style scoped>

</style>
